<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-select
                    :options="especialidadesReguladas"
                    :validations="validations.especialidadeRegulada"
                    label="Especialidade regulada"
                    show-default-option
                    text-field="descricao"
                    v-model="model.especialidadeReguladaId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-button
                    :label="false"
                    @click="$refs.Form.validate(add)"
                    color="primary"
                >
                    Incluir
                </rkm-button>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { object } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                especialidadeRegulada: { required: true },
            }
        },
        especialidadesReguladas() {

            return this.data.model.reguladores.find(r => r.infraestruturaId === this.regulador.infraestruturaId)
                .especialidades
                .filter(e => e.ativo && !this.especialidadesReguladasDoReguladorIds.includes(e.id))
                .map(especialidade => ({
                    id: especialidade.id,
                    codigo: especialidade.codigo,
                    nome: especialidade.nome,
                    descricao: `${especialidade.codigo} - ${especialidade.nome}`
                }))
                .sort((a, b) => a.descricao.localeCompare(b.descricao))
        },
        especialidadesReguladasDoReguladorIds() {

            return this.regulador.especialidades.map(e => e.id)
        }
    },
    data: () => ({
        model: {
            especialidadeReguladaId: null,
        }
    }),
    methods: {
        add() {

            this.regulador.especialidades.push(this.prepareData())

            this.resetForm()
        },
        prepareData() {

            return this.clone(this.especialidadesReguladas.find(e => e.id === this.model.especialidadeReguladaId))
        },
        resetForm() {

            this.model.especialidadeReguladaId = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        }
    },
    mixins: [object],
    props: {
        data: { type: Object, required: true },
        regulador: { type: Object, required: true },
    },
}
</script>